require('./change-values.scss')

module.exports = {
  template: require('./change-values.pug')()
  controller: require('./change-values.ctrl')
  bindings:
    changes: '<'
    prefix: '@'
}
